import { render, staticRenderFns } from "./MeetingAgenda.vue?vue&type=template&id=21c63dd3&"
import script from "./MeetingAgenda.vue?vue&type=script&lang=js&"
export * from "./MeetingAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c63dd3')) {
      api.createRecord('21c63dd3', component.options)
    } else {
      api.reload('21c63dd3', component.options)
    }
    module.hot.accept("./MeetingAgenda.vue?vue&type=template&id=21c63dd3&", function () {
      api.rerender('21c63dd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/agendas/MeetingAgenda.vue"
export default component.exports